// extracted by mini-css-extract-plugin
export var completionBody = "_ln-2";
export var completionCard = "_ln-0";
export var completionFooter = "_ln-3";
export var completionTitle = "_ln-1";